import axios from "axios";

const API_URL = `${process.env.VUE_APP_APIURL}/api/app`;
const obituaryURL = `${API_URL}/obituary`;

const obituaryClient = axios.create({
  baseURL: obituaryURL
});

// 부고장 조회
const requestObituary = ({ id, obituaryNo, memberId }) => {
  return obituaryClient.get(
    `?id=${id}&memberId=${memberId}&obituaryNo=${obituaryNo}`
  );
};

// 부고장 설정 조회
const requestObituaryMemberSetting = memberId => {
  return obituaryClient.get(`/member?memberId=${memberId}`);
};

// 부고장 설정 저장
const requestSaveObituaryMemberSetting = parameter => {
  return obituaryClient.post(`/member/update`, parameter);
};

// 부고 추모 메시지 등록
const requestObituaryMsgSend = parameter => {
  return obituaryClient.post(`/reg-message`, parameter);
};

const requestObituaryMsgPwdCheck = async params => {
  return obituaryClient
    .post(`/check-pwd/message`, params)
    .then(res => {
      const {
        data: { code, message, result }
      } = res;

      if (code === "E001") {
        alert(message);
        return;
      }

      return result;
    })
    .catch(err => {
      alert("네트워크 문제로 실패하였습니다. 다시 시도하여 주십시요");
      console.error(err);
    });
};

// 조의금 계좌 안내 메시지 받기
const requestAccountMsgSend = parameter => {
  return axios.get(
    `${API_URL}/sms/send-account?id=${parameter.id}&phone=${parameter.phone}`
  );
};

const requestObituaryOnlySend = ({
  id,
  msgType,
  smsBody,
  showType,
  accountShowType
}) => {
  return obituaryClient.post(`/send?id=${id}`, {
    msgType,
    smsBody,
    showType,
    accountShowType
  });
};

// 부고장 설정 계좌 인증
const requestAccountCertify = parameter => {
  return axios.get(
    `${API_URL}/popbill/account?accountNumber=${parameter.accountNumber}&bankCode=${parameter.bankCode}`
  );
};

// 개인정보 동의
const requestObituarAgree = async params => {
  return obituaryClient
    .post(`/agree`, params)
    .then(res => {
      const {
        data: { code, message, result }
      } = res;

      if (code === "E001") {
        alert(message);
        return;
      }

      return result;
    })
    .catch(err => {
      alert("네트워크 문제로 실패하였습니다. 다시 시도하여 주십시요");
      console.error(err);
    });
};

export {
  requestObituary,
  requestObituaryMsgSend,
  requestObituaryMsgPwdCheck,
  requestAccountMsgSend,
  requestObituaryOnlySend,
  requestObituaryMemberSetting,
  requestSaveObituaryMemberSetting,
  requestAccountCertify,
  requestObituarAgree
};
